// You can write more code here

/* START OF COMPILED CODE */

import UIBlocker from "../GeneralUI/UIBlocker";
import DefaultButton from "../GeneralUI/Buttons/DefaultButton";
import DefaultConfirmButton_m from "../DefaultConfirmButton_m";
/* START-USER-IMPORTS */
import { BiomeImages, MentorNames } from '@/common/types/LectioTypes';
import { getStudent } from '@/game/GameComponents/PhaserGame/GameInstance';
import EventsManager from '@/game/GameComponents/PhaserGame/Managers/EventsManager';
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { getSceneManager } from '@/game/GameComponents/PhaserGame/Managers/SceneManager';
import GAME_EVENTS from '@/game/GameComponents/PhaserGame/Utils/gameEventsDef';
import { PhaserAudioManager } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import {
  getAnchorPlugin,
  getBiomeFromStudentLevel,
  waitForSeconds,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import LevelMap from '@/game/scenes/LevelMap';
/* END-USER-IMPORTS */

export default class AssessmentConclusionUI extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		// uIBlocker
		const uIBlocker = new UIBlocker(scene, 0, 0);
		this.add(uIBlocker);

		// DesktopView
		const desktopView = scene.add.container(0, 0);
		desktopView.visible = false;
		this.add(desktopView);

		// mainContainer
		const mainContainer = scene.add.container(512, 384);
		desktopView.add(mainContainer);

		// backing
		const backing = scene.add.nineslice(0, -28, "Hud1", undefined, 128, 104, 8, 8, 8, 8);
		backing.scaleX = 4;
		backing.scaleY = 4;
		mainContainer.add(backing);

		// mentorImage
		const mentorImage = scene.add.image(-352, -32, "Spellcaster_Mentor_1_Forest_Login_GlowNShade");
		mentorImage.scaleX = 0.5;
		mentorImage.scaleY = 0.5;
		mainContainer.add(mentorImage);

		// descriptionText
		const descriptionText = scene.add.bitmapText(0, -152, "Aronui", "OK! Let's head to realm to get going!");
		descriptionText.setOrigin(0.5, 0.5);
		descriptionText.tintTopLeft = 5387071;
		descriptionText.tintTopRight = 5387071;
		descriptionText.tintBottomLeft = 5387071;
		descriptionText.tintBottomRight = 5387071;
		descriptionText.text = "OK! Let's head to realm to get going!";
		descriptionText.fontSize = -18;
		descriptionText.maxWidth = 300;
		mainContainer.add(descriptionText);

		// biome
		const biome = scene.add.image(0, -24, "1x1sprite");
		mainContainer.add(biome);

		// continueButton
		const continueButton = new DefaultButton(scene, 0, 136);
		mainContainer.add(continueButton);

		// disclaimerText
		const disclaimerText = scene.add.bitmapText(0, 96, "Aronui", "(Your educator may change this for you later!)");
		disclaimerText.setOrigin(0.5, 0.5);
		disclaimerText.tintTopLeft = 5387071;
		disclaimerText.tintTopRight = 5387071;
		disclaimerText.tintBottomLeft = 5387071;
		disclaimerText.tintBottomRight = 5387071;
		disclaimerText.text = "(Your educator may change this for you later!)";
		disclaimerText.fontSize = -14;
		disclaimerText.maxWidth = 500;
		mainContainer.add(disclaimerText);

		// headerContainer
		const headerContainer = scene.add.container(0, -224);
		mainContainer.add(headerContainer);

		// headerBacking
		const headerBacking = scene.add.nineslice(0, 0, "Hud2", undefined, 96, 16, 4, 4, 4, 8);
		headerBacking.scaleX = 4;
		headerBacking.scaleY = 4;
		headerContainer.add(headerBacking);

		// bitmaptext_1
		const bitmaptext_1 = scene.add.bitmapText(0, 0, "Aronui", "Assessment Complete");
		bitmaptext_1.setOrigin(0.5, 0.5);
		bitmaptext_1.tintTopLeft = 985612;
		bitmaptext_1.tintTopRight = 985612;
		bitmaptext_1.tintBottomLeft = 985612;
		bitmaptext_1.tintBottomRight = 985612;
		bitmaptext_1.text = "Assessment Complete";
		bitmaptext_1.fontSize = -32;
		headerContainer.add(bitmaptext_1);

		// mobileView
		const mobileView = scene.add.container(0, 0);
		this.add(mobileView);

		// mainContainer_m
		const mainContainer_m = scene.add.container(339, 188);
		mobileView.add(mainContainer_m);

		// backing_m
		const backing_m = scene.add.nineslice(85, 0, "Hud1", undefined, 200, 160, 8, 8, 8, 8);
		backing_m.scaleX = 2;
		backing_m.scaleY = 2;
		mainContainer_m.add(backing_m);

		// mentorImage_m
		const mentorImage_m = scene.add.image(-227, 4, "Spellcaster_Mentor_1_Forest_Login_GlowNShade");
		mentorImage_m.scaleX = 0.4;
		mentorImage_m.scaleY = 0.4;
		mainContainer_m.add(mentorImage_m);

		// continueButton_m
		const continueButton_m = new DefaultConfirmButton_m(scene, 85, 120);
		mainContainer_m.add(continueButton_m);

		// descriptionText_m
		const descriptionText_m = scene.add.bitmapText(85, -116, "Aronui", "OK! Let's head to realm to get going!");
		descriptionText_m.setOrigin(0.5, 0.5);
		descriptionText_m.tintTopLeft = 5387071;
		descriptionText_m.tintTopRight = 5387071;
		descriptionText_m.tintBottomLeft = 5387071;
		descriptionText_m.tintBottomRight = 5387071;
		descriptionText_m.text = "OK! Let's head to realm to get going!";
		descriptionText_m.fontSize = -16;
		descriptionText_m.maxWidth = 600;
		mainContainer_m.add(descriptionText_m);

		// biome_m
		const biome_m = scene.add.image(85, -24, "duel-arena-spring");
		biome_m.scaleX = 0.75;
		biome_m.scaleY = 0.75;
		mainContainer_m.add(biome_m);

		// disclaimerText_m
		const disclaimerText_m = scene.add.bitmapText(85, 72, "Aronui", "(Your educator may change this for you later!)");
		disclaimerText_m.setOrigin(0.5, 0.5);
		disclaimerText_m.tintTopLeft = 5387071;
		disclaimerText_m.tintTopRight = 5387071;
		disclaimerText_m.tintBottomLeft = 5387071;
		disclaimerText_m.tintBottomRight = 5387071;
		disclaimerText_m.text = "(Your educator may change this for you later!)";
		disclaimerText_m.fontSize = -12;
		disclaimerText_m.maxWidth = 500;
		mainContainer_m.add(disclaimerText_m);

		// headerContainer_m
		const headerContainer_m = scene.add.container(85, -156);
		mainContainer_m.add(headerContainer_m);

		// headerBacking_1
		const headerBacking_1 = scene.add.nineslice(0, 0, "Hud2", undefined, 140, 22, 4, 4, 4, 8);
		headerBacking_1.scaleX = 2;
		headerBacking_1.scaleY = 2;
		headerContainer_m.add(headerBacking_1);

		// headerText_
		const headerText_ = scene.add.bitmapText(0, 0, "Aronui", "Assessment Complete");
		headerText_.setOrigin(0.5, 0.5);
		headerText_.tintTopLeft = 985612;
		headerText_.tintTopRight = 985612;
		headerText_.tintBottomLeft = 985612;
		headerText_.tintBottomRight = 985612;
		headerText_.text = "Assessment Complete";
		headerText_.fontSize = -24;
		headerContainer_m.add(headerText_);

		// continueButton (prefab fields)
		continueButton.buttonText = "OK";

		// continueButton_m (prefab fields)
		continueButton_m.buttonText = "Continue";

		this.descriptionText = descriptionText;
		this.biome = biome;
		this.continueButton = continueButton;
		this.mainContainer = mainContainer;
		this.desktopView = desktopView;
		this.continueButton_m = continueButton_m;
		this.descriptionText_m = descriptionText_m;
		this.biome_m = biome_m;
		this.mainContainer_m = mainContainer_m;
		this.mobileView = mobileView;

		/* START-USER-CTR-CODE */
    this.initialize();
    /* END-USER-CTR-CODE */
	}

	public descriptionText: Phaser.GameObjects.BitmapText;
	public biome: Phaser.GameObjects.Image;
	public continueButton: DefaultButton;
	private mainContainer: Phaser.GameObjects.Container;
	public desktopView: Phaser.GameObjects.Container;
	public continueButton_m: DefaultConfirmButton_m;
	public descriptionText_m: Phaser.GameObjects.BitmapText;
	public biome_m: Phaser.GameObjects.Image;
	private mainContainer_m: Phaser.GameObjects.Container;
	public mobileView: Phaser.GameObjects.Container;

	/* START-USER-CODE */

  async initialize() {
    this.setDepth(999);
    this.getResponsiveElements('continueButton').forEach(
      (continueButton: DefaultButton) => {
        continueButton.controller.setSubmissionCallback(() => {
          getSceneManager()?.launchScene('LevelMap', LevelMap, {
            type: 'gameplay',
            stopActiveScene: true,
          });
          PhaserAudioManager.restartMusic();
        });
      },
    );

    this.initializeResponsiveness();

    EventsManager.registerEventOnce(
      this.scene,
      GAME_EVENTS.PLAYER_UPDATED_POST_ASSESSMENT,
      this.handleAssessmentCompleted,
      this,
    );

    // await waitForSeconds(this.scene.time, 3);
    // this.handleAssessmentCompleted();
  }

  getResponsiveElements(key: keyof AssessmentConclusionUI) {
    return ResponsivenessManager.GetAllResponsiveComponentsFromContainer(
      this,
      key,
    );
  }

  async handleAssessmentCompleted() {
    await waitForSeconds(this.scene.time, 1);
    this.setVisible(true);
    const biome = getBiomeFromStudentLevel(getStudent().level);
    this.getResponsiveElements('descriptionText').forEach(
      (descriptionText: Phaser.GameObjects.BitmapText) => {
        descriptionText.setText(
          `OK! Let's head to ${MentorNames[biome]}'s realm!`,
        );
      },
    );

    const sound1 = this.scene.sound.add('greenleaf-assessment-complete-0');
    const sound2 = this.scene.sound.add('greenleaf-assessment-complete-1');
    const sound3 = this.scene.sound.add(
      this.getMentorRealmAudioFromBiome(biome),
    );

    this.getResponsiveElements('biome').forEach(
      (biomeImage: Phaser.GameObjects.Image) => {
        biomeImage.setTexture(BiomeImages[biome]);
      },
    );

    await waitForSeconds(this.scene.time, 1);
    sound1.play();
    sound1.once('complete', () => {
      sound2.play();
      sound2.once('complete', () => {
        sound3.play();
      });
    });
  }

  getMentorRealmAudioFromBiome(biome: number) {
    return [
      'greenleaf-assessment-complete-my-realm',
      'greenleaf-assessment-complete-springtide-realm',
      'greenleaf-assessment-complete-dune-realm',
      'greenleaf-assessment-complete-avalanche-realm',
      'greenleaf-assessment-complete-monsoon-realm',
    ][biome];
  }

  initializeResponsiveness() {
    console.log('responsiveness');
    ResponsivenessManager.InitializeResponsiveBreakpoints({
      scene: this.scene,
      desktopView: this.desktopView,
      mobileView: this.mobileView,
    });

    const anchor = getAnchorPlugin(this.scene);
    if (anchor) {
      console.log('anchor');
      anchor.add(this.mainContainer, {
        centerX: '50%',
        centerY: '50%',
      });

      anchor.add(this.mainContainer_m, {
        centerX: '50%',
        centerY: '50%',
      });
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
